"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siZones = void 0;
var siZones = exports.siZones = [{
  id: 'LJUBLJANA',
  name: 'Ljubljana',
  country: 'SI',
  cornerNW: {
    latitude: 46.1512,
    longitude: 14.4276
  },
  cornerSE: {
    latitude: 45.9766,
    longitude: 14.6276
  },
  subZones: [{
    name: 'Ljubljana Centre-ville',
    zipcodes: {
      1000: {
        label: '1000'
      }
    }
  }, {
    name: 'Ljubljana Šentvid',
    zipcodes: {
      1210: {
        label: '1210'
      }
    }
  }, {
    name: 'Ljubljana Brezovica',
    zipcodes: {
      1270: {
        label: '1270'
      }
    }
  }, {
    name: 'Ljubljana Mokronog',
    zipcodes: {
      4270: {
        label: '4270'
      }
    }
  }]
}];